import React, { useState, useCallback, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import Col from 'react-bootstrap/Col';
import clsx from 'clsx';
import Text from '../components/Text';
import { Article, Product} from '../types';
import { Helmet } from 'react-helmet';
import { Row } from 'react-bootstrap';
import ProductCard from '../components/ProductCard';
import ImagePicker from './ProductDetails/ImagePicker';
import Slider from '../components/Slider';
import IconButton from '../components/IconButton';
import { FaShare, FaShareAlt } from 'react-icons/fa';
import { track } from '../services/mixpanelService';
import Button from '../components/Button';
import { convertToPlainText } from '../services/helpers';


export interface ArticleDetailsProps {
    article: Article;
}

const ArticleDetails: React.FC<ArticleDetailsProps> = ({ article }) => {
  const classes = useStyles();
  
  
  const handleShare = useCallback(() => {
    try {
      if (typeof window.navigator.share === 'function') {
        window.navigator.share({
          text:  article.content,
          url: window.location.href,
        });
        track("share");
      }
    } catch (e) { }
  }, [article]);
  return (
    <>
      <Helmet>
        <title>{article.username} | twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
          <script type="application/ld+json">
          {
          `{
            "@context": "https://schema.org/",
            "@type": "Article",
            "headline": "${article.title}",
            "articleBody":"${convertToPlainText(article.content)}",
            "image": {
              "@type": "ImageObject",
              "url": "${article.cover}"
            },
            "author": {
              "@type": "Person",
              "name": "${article.user.username}"
            },
            "datePublished": "${article.created_at}"
          }`
          }
          </script>
      </Helmet>
      <div className={classes.containerArticle}>
        <Row>
        
            <Col md={12} lg={9}>
            <Row  className={classes.leftColumn}>
            <Col md={12} lg={12}>
                <div className={classes.header}>
                  <Text className={classes.title} bold fontSize="size2">{article.title}</Text>
                  <div className={classes.headerRightBlock}>
                    <p className={classes.aboutArticle}>{article.user.name} <span className={classes.separator}>|</span> {article.createdAtAsString}</p>
                    <Button
                    className={clsx('mr-2', classes.shareBtn)}
                    onClick={handleShare}
                    color="primary"
                    rounded
                    >
                  <FaShareAlt className={classes.shareIcon} />
                </Button>
                  </div>
                </div>
                <ImagePicker articleImage={true} images={[]} variantsImage={[]} primaryImage={article.cover}  />
            </Col>
            <Col md={12} lg={12}>
                <div dangerouslySetInnerHTML={{__html: article.content}}/>
            </Col>
            </Row>
            </Col>
            <Col lg={3} className={classes.big}>
              <Text bold className={classes.ProductsRelated}>Products related</Text>
                {article.products.map((product:Product)=>(
                <div
                  className={classes.productWrapper}
                  >
                  <ProductCard
                  product={product}
                  />
                </div>
                ))}
            </Col>
          <Col md={12} className={classes.medium}>
            <Text bold className={classes.ProductsRelated}>Products related</Text>
            <Slider
             responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                },
              },
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  initialSlide: 2,
                },
              }, {
                breakpoint: 800,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 1,
                },
              }]}>
              {article.products.map((product) => (
                <div
                  key={product.id}
                  className={classes.productSlideWrapper}
                >
                  <ProductCard
                    className={classes.productSlide}
                    product={product}
                  />
                </div>
              ))}
            </Slider>
        </Col>
        </Row>
      </div>
    </>
  );
};
const useStyles = createUseStyles({
  medium:{
    marginTop:'30px',
    display: 'none',
  },
  big:{},
  productWrapper: {
    position: 'relative',
    margin:'2rem 0', 
  },
    containerArticle:{
        width: '90%',
        margin: '2em auto',
    },
    ProductsRelated:{
      fontSize: '1.3em',
    },
    leftColumn:{
        backgroundColor:'#fff',
        paddingTop:'2em',
        borderRadius: '20px',
        margin: '0 auto' 
    },
    headerRightBlock:{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title:{
        fontSize: '1.65rem',
    },
    header:{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      paddingBottom: '10px',
    },
    shareIcon: {
      marginBottom: '3px'
    },
    shareBtn: {
      width: '30px',
      height: '30px',
      padding: '0px !important',
    },
    aboutArticle:{
      paddingBottom: '0.5em',
      fontSize: '1.1em',
      margin:'0 7px',
      color:'#847b7b'
    },
    separator:{
      fontWeight:'bold',
    },
    productSlideWrapper: {
      paddingLeft: '10px',
      paddingRight: '10px',
      minHeight: '400px',
      display: 'flex !important',
      flexDirection: 'column',
      position: 'relative'
    },
    productSlide: {
      flex: 1,
    },
    '@media (max-width: 1290px)':{
      productWrapper: {
        width: '250px',
      },
    },
    '@media (max-width: 1000px)':{
      big: {
        display: 'none',
      },
      medium:{
        display: 'block'
      },
    },
    '@media (max-width: 400px)':{
      title:{fontSize: '1.25rem'},
      aboutArticle:{fontSize: '0.9em'},
    },
});
export default ArticleDetails;
